export default __webpack_public_path__ + "static/media/smartSearch_en_d.ce2ea2f4.svg";